import { FaRobot, FaChartLine, FaBolt } from "react-icons/fa";

export const en = {
  extraTitle: "More reasons to choose Sweet Trading",
  extraText: "We are a team passionate about technology and financial markets. We work every day to provide you with reliable, high-quality tools that are always one step ahead of the market.",
  heroTitle: "A NEW TRADING GENERATION",
  heroSubtitle: " 98% of traders fail, but not today, not anymore. we are finally here to chage that statistic forever, be part of the revolution Now.",
  buttonText: "Discover Candy Bot",
  buttonLink: "#promo-section",
  whyTitle: "Why choose Candy Bot?",
  whyText: "Automation, intelligence, speed. All with a design that makes you want to trade every day.",
  disclaimer: "All information provided on this site is intended solely for educational purposes related to trading on financial markets and does not constitute in any way a specific investment recommendation, business recommendation, investment opportunity analysis or other general recommendation regarding the trading of financial instruments. The information on this site is not directed at residents of any country or jurisdiction where such distribution or use would be contrary to local laws or regulations.",

  clockSection: {
    line1: "Every second, 24 hours a day, 5 days a week our bot analyzes the markets",
    line2: " to identify the best trading opportunities."
  },

  processSection: {
    title: "The 3-Step Process",
    subtitle: "From signup to profit withdrawal – simple and transparent",
    steps: [
      {
        number: "1",
        title: "Purchase Your Plan",
        description: "Choose the plan that best suits your needs and complete your purchase in just a few clicks.",
        timeLabel: "2 minutes"
      },
      {
        number: "2",
        title: "Start Trading",
        description: "Start trading by following the instructions provided in your selected plan. Our system will guide you every step of the way.",
        timeLabel: "Varies"
      },
      {
        number: "3",
        title: "Withdraw Profits",
        description: "Receive your earnings directly to your bank account or preferred wallet within 24–48 hours.",
        timeLabel: "24–48 hours"
      }
    ],
    ctaText: "Try Candy Bot Free"
  },

  whySection: {
    title: "Sweet & Powerful",
    description: "Is there anything sweeter than money? Yes! Easy money. Unfortunately, easy money doesn't exist — but Candy Bot is here to sweeten the deal and do the hard work for you.",
    features: [
      {
        title: "AI Power",
        highlight: "responsable of inevitable changes",
        description: "Candy Bot uses cutting-edge AI with proprietary neural networks to analyze global markets in real-time. Our system combines deep learning, pattern recognition, and predictive analysis to dynamically adapt to volatile market conditions.",
        image: "/ai.jpg",
        icon: "FaRobot"
      },
      {
        title: "Outstanding Results",
        highlight: "The one, the first, the best",
        description: "Created to bring the best opportunities to life. Optimized to minimize errors and maximize profits. Our adaptive algorithms continuously refine trading strategies and implement robust risk management protocols.",
        image: "/performance.jpg",
        icon: "FaChartLine"
      },
      {
        title: "Market-Optimized",
        highlight: "Timing is everything",
        description: "Forex, stocks or crypto — each model features a specific specialization tailored to the market context in which it operates, allowing it to seize the winning moment every time.",
        image: "/forex.jpg",
        icon: "FaBolt"
      }
    ]
  },

  tryBot: "Try Candy Bot Free",
  sweetPower: "Sweet and Powerful",
  sweetText: "Is there anything sweeter than money? Yes! Easy money. Unfortunately, there's no such thing as easy money, but Candy Bot is ready to sweeten the pill and do the hard work for you.",
  aiTitle: "AI Power",
  aiSubtitle: "Artificial Intelligence",
  aiText: "Candy Bot uses the most advanced AI to analyze markets in real time. Thanks to a powered neural engine, it combines pattern recognition, clustering and predictive strategies to dynamically adapt to every market condition.",
  learnMore: "Learn more →",
  performanceTitle: "Consistent Performance",
  performanceSubtitle: "Exceptional Performance",
  performanceText: "Optimized to reduce errors and maximize profits. Our system constantly optimizes strategies to maximize returns while minimizing risks.",
  forexTitle: "Forex Optimized",
  forexSubtitle: "Supreme Speed",
  forexText: "Acts in milliseconds when key patterns are detected. Reacts to market changes in milliseconds, always ensuring perfect timing for every trade.",

  numbersTitle: "By The Numbers",
  numbersSubtitle: "Our community grows every day. Join thousands of satisfied traders.",
  stats: [
    { value: "26+", label: "Profitable Months", desc: "Steady growth since our launch" },
    { value: "7,000+", label: "Community Members", desc: "Join our family" },
    { value: "19,529", label: "Successful Trades", desc: "Executed with profit" },
    { value: "89.7%", label: "Success Rate", desc: "Overall performance" }
  ],

  offerTitle: "Special Offer",
  offerSubtitle: "Candy Bot Pro",
  offerText: "The smart trading solution that works for you",

  plans: [
    {
      name: "Candy Bot",
      desc: "To start your journey",
      price: "$0",
      originalPrice: "$169",
      period: "for the first 24 hours",
      features: ["Full bot access", "24/7 Support", "Advanced dashboard", "AI predictive analysis"],
      cta: "Start Free Trial",
      isNew: true
    }
  ],

  promo: {
    badge: "Special Offer",
    title: "Candy Bot",
    subtitle: "To celebrate the launch of our new bot and proudly mark this milestone, we have decided to offer it at an unbeatable price, <strong>available for a limited time only</strong>.",
    cardTitle: "Candy Bot Standard",
    cardSubtitle: "Start your journey today",
    newBadge: "NEW",
    oldPrice: "$99",
    newPrice: "$0",
    limitedNote: "Limited time offer",
    features: [
      "Full bot access",
      "24/7 support",
      "Advanced dashboard",
      "AI-powered analytics"
    ],
    button: "Discover Candy Bot",
    promoTitle: "Limited-Time Promotion",
    promoText: "Sign up by <strong>now</strong> and get full access — no payment, no commitment.",
    endsSoon: "Offer ends soon!",
    benefits: [
      "✅ Zero cost",
      "✅ Cancel anytime",
      "✅ Instant activation",
      "✅ Free updates"
    ],
    guarantee: "🔒 14-day money-back guarantee"
  },

  promoTitle: "Limited Promotion",
  promoText: "To celebrate the launch of Candy Bot Pro, we're offering full free access to the new Bot for 24 hours to all new users registered by May 6th.",
  promoItems: ["✅ No cost, no investment", "✅ No commitment", "✅ Dedicated support", "✅ Free updates"],
  promoGuarantee: "14-day satisfaction guarantee",

  compareTitle: "Compare Plans",
  compareSubtitle: "From traditional solutions to advanced AI, choose the perfect version for your needs",

  compareSection: {
    planTitle: "Candy Bot Standard",
    planSubtitle: "Everything you need to get started",
    priceFree: "$0",
    priceOld: "$99",
    offerNote: "Limited time offer",
    features: [
      
      "7 Forex pairs",
      "24/7 Support",
      "Step-by-step guide",
      "70% profit share",
      "Minimum investment $100"
    ],
    button: "Get it free now",
    popupTitle: "You're getting Candy Bot Standard",
    popupSubtitle: "Enter your details to claim the free offer",
    form: {
      name: "Full Name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      submit: "Register & Get Access"
    },
    disclaimer: "By clicking \"Register\" you accept our",
    terms: "Terms of Service",
    privacy: "Privacy Policy"
  },
  comingSoonSection: {
  badge: "COMING SOON",
  title: "Candy Bot Pro",
  subtitle: "Next-Gen AI Trading",
  priceLabel: "Coming soon",
  priceDescription: "Coming soon",
  features: [
    "Stock/Forex/Crypto AI model",
    "3 different markets",
    "Priority 24/7 support",
    "Step-by-step setting guide",
    "70% profit split",
    "Minimum investment $500"
  ],
  buttonText: "Available soon"
},
   faq: {
    title: "Domande Frequenti",
    description: "Tutte le risposte alle domande più comuni sul nostro servizio",
    items: [
      {
        question: "Come posso iniziare a usare Candy Bot?",
        answer: "Clicca semplicemente su 'Inizia la Prova Gratuita' e segui il processo di registrazione."
      },
      {
        question: "E se non conosco nulla di trading?",
        answer: "Candy Bot è progettato per tutti i livelli. I principianti possono usare le modalità automatizzate mentre i trader avanzati possono personalizzare le strategie."
      },
      {
        question: "Qual è il rendimento medio mensile?",
        answer: "I dati storici mostrano un rendimento medio mensile del 7-12%, anche se le performance passate non garantiscono risultati futuri."
      },
      {
        question: "A chi sono adatti i Bot?",
        answer: "Ideale per professionisti occupati, principianti e chiunque voglia automatizzare la propria strategia di trading."
      },
      {
        question: "Posso usare più bot contemporaneamente?",
        answer: "Sì! Puoi eseguire più bot con strategie diverse contemporaneamente."
      }
    ]
  },


  comingSoonSection: {
    badge: "COMING SOON",
    title: "Candy Bot Pro",
    subtitle: "Next-Gen AI Trading",
    priceLabel: "Coming soon",
    priceDescription: "Coming soon",
    features: [
      "Stock/Forex/Crypto AI model",
      "3 different markets",
      "Priority 24/7 support",
      "Step-by-step setting guide",
      "70% profit split",
      "Minimum investment $500"
    ],
    buttonText: "Available soon"
  },
  faq: {
    title: "Frequently Asked Questions",
    description: "All the answers to the most common questions about our service",
    items: [
      {
        question: "How do I start using Candy Bot?",
        answer: "Simply click on 'Start Free Trial' and follow the registration process."
      },
      {
        question: "What if I know nothing about trading?",
        answer: "Don’t worry: Candy Bot was specifically designed for those who want to approach the world of trading without facing the usual risks, or simply for those looking for an easy and safe way to earn additional monthly income."
      },
      {
        question: "What is the average monthly return?",
        answer: "Returns vary based on market conditions and your chosen plan, but with the right capital and bot, it's possible to earn a full monthly income."
      },
      {
        question: "Who are these bots for?",
        answer: "Perfect for anyone 18+ looking to trade risk-free or effortlessly boost their monthly income."
      },
      {
        question: "Can I run multiple bots at the same time?",
        answer: "Yes! You can activate multiple bots, but each must run on separate accounts to avoid conflicts"
      },
      {
  question: "What is Forex?",
  answer: "Forex is the market where currencies like the euro and dollar are traded. It's the largest in the world, open 24 hours a day, and allows you to earn by taking advantage of exchange rate fluctuations."
}

    ]
  },

  comparisonPlans: [
    {
      name: "Gen I Bots",
      desc: "Traditional trading",
      price: "$89",
      originalPrice: "$99",
      discount: "-10%",
      features: ["Fewer trades", "Basic market analysis", "Email support", "3 Forex pairs"],
      cta: "Buy Now",
      type: "One-time (10% discount)"
    },
    {
      name: "Candy Bot Standard",
      desc: "First-gen AI",
      price: "$0",
      originalPrice: "$169",
      type: "Free for limited time",
      features: ["Unlimited trades", "AI predictive analysis", "12 Forex pairs", "Priority 24/7 support", "Advanced dashboard"],
      cta: "Get It Free",
      isOffer: true
    },
    {
      name: "Enterprise",
      desc: "Custom solution",
      price: "Custom",
      type: "Price on request",
      features: ["Custom configuration", "Dedicated API integration", "24/7 technical support", "Custom AI models", "White-label solution", "Personalized training"],
      cta: "Coming Soon",
      isComing: true
    }
  ],

  faqTitle: "Frequently Asked Questions",
  faqSubtitle: "All answers to the most common questions about our service",
  faqItems: [
    { question: "How can I start using Candy Bot?", answer: "Simply click on 'Start Free Trial' and follow the registration process." },
    { question: "What if I know nothing about trading?", answer: "Candy Bot is designed for all levels. Beginners can use automated modes while advanced traders can customize strategies." },
    { question: "What is the average monthly return?", answer: "Historical data shows an average 7–12% monthly return, though past performance doesn't guarantee future results." },
    { question: "Who are the Bots suitable for?", answer: "Ideal for busy professionals, beginners, and anyone wanting to automate their trading strategy." },
    { question: "Can I use multiple bots simultaneously?", answer: "Yes! You can run multiple bots with different strategies simultaneously." }
  ],

  legalTitle: "Legal & Support",
  legalLinks: ["Terms", "Privacy"],
  supportEmail: "support@therealworld.net",
  supportChat: "Typically reply in minutes",

  copyright: "© 2024–2025 Sweet Trading Inc. All rights reserved. 🍬",

  features: [
    { title: "Smart AI", desc: "Analyzes and learns from markets in real-time." },
    { title: "Consistent Performance", desc: "Optimized to reduce errors and maximize profits." },
    { title: "Lightning Fast", desc: "Acts in milliseconds when key patterns are detected." },
    { title: "Active Community", desc: "Ongoing support and shared strategies." }
  ],

  sectionTitles: {
    process: "3-Step Process",
    features: "Key Features",
    numbers: "By The Numbers",
    offer: "Special Offer",
    compare: "Plan Comparison",
    faq: "FAQ",
    support: "Support",
    bots: "Bots"
  },

  planDetails: {
    freeTrial: "24h FREE Trial",
    includes: "Includes:",
    mostPopular: "MOST POPULAR",
    bestValue: "BEST VALUE"
  },

  ctaSection: {
    title: "Ready to Transform Your Trading?",
    subtitle: "Join thousands of satisfied traders today",
    button: "Start Free Trial"
  },

  buttons: {
    backToTop: "Back to top",
    contactSupport: "Contact support",
    downloadApp: "Download app",
    login: "Login"
  },

  legal: {
    riskWarning: "RISK WARNING: Trading involves high risks and may not be suitable for all investors.",
    performanceDisclaimer: "Past performance is not indicative of future results."
  },

  languages: {
    english: "English",
    italian: "Italian",
    german: "German"
  }
};
